import CustomError from '../Utilities/CustomError'

import * as EntityConstants from './EntityConstants'
import Layer from './Layer'

export default class Spline {
    constructor(json) {
        this['$type'] = json['$type']
        this.startPoint = undefined
        this.endPoint = undefined
        this.layer = undefined
        this.isLineTypeSolid = undefined
        this.type = undefined
        this.toSvg = undefined
        this.lineApproximation = []

        const jsonValid =
            json &&
            Object.prototype.hasOwnProperty.call(json, 'layer') &&
            Object.prototype.hasOwnProperty.call(json, 'isLineTypeSolid') &&
            Object.prototype.hasOwnProperty.call(json, 'type')
        Object.prototype.hasOwnProperty.call(json, 'lineApproximation')

        if (jsonValid) {
            Object.assign(this, json)
            this.layer = new Layer(json.layer)
        } else {
            throw new CustomError('Invalid json supplied', 'InvalidJSONError')
        }
    }

    getSvgPathStr(lastPt) {
        let pathStr = ''
        const lastPtMeetsStartPoint =
            lastPt &&
            Math.abs(lastPt.x - this.lineApproximation[0].startPoint.x) < EntityConstants.POINT_COMPARISON_PRECISION &&
            Math.abs(lastPt.y - this.lineApproximation[0].startPoint.y) < EntityConstants.POINT_COMPARISON_PRECISION

        if (!lastPt || !lastPtMeetsStartPoint) {
            pathStr += !lastPtMeetsStartPoint ? ' ' : ''
            pathStr += 'M' + this.lineApproximation[0].startPoint.x + ' ' + this.lineApproximation[0].startPoint.y
        }

        this.lineApproximation.forEach((line) => {
            pathStr += ' L' + line.endPoint.x + ' ' + line.endPoint.y
        })

        return pathStr
    }
}

Spline.ToolpathType = 'DtoSpline'
